export const LOGIN_TITLE: string = 'Enter your info to login:';
export const USERNAME_PLACEHOLDER: string = 'username/email';
export const PASSWORD_PLACEHOLDER: string = 'password';
export const LOGIN_SUBMIT_TEXT: string = 'Login';
